import { API_URL } from 'core/infra/environment'
import { HttpClient, type HttpClientConfig } from 'core/infra/http/HttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

type GetShipmentsMetadataFactoryDependencies = {
  repository: ShipmentRepository
}

type Params = {
  config: Partial<HttpClientConfig>
}

export function getShipmentsMetadataFactory({
  repository,
}: GetShipmentsMetadataFactoryDependencies) {
  return async function getShipmentsMetadata({ config }: Params) {
    try {
      return await repository.getShipmentsMetadata(config)
    } catch (error) {
      throw new Error('Could not get shipments metadata', { cause: error as Error })
    }
  }
}

export function getShipmentsMetadata(params: Params) {
  const httpClient = new HttpClient(API_URL)

  const repository = new ShipmentRepository({ httpClient })
  const newGetShipmentsMetadata = getShipmentsMetadataFactory({
    repository,
  })
  return newGetShipmentsMetadata(params)
}
